<template>
  <div>
    <div class="header">
      <div class="switch-data-type">
        <div v-for="type, index in data_types" :key="index" class="switch-btn" @click="switchDataType(type)"
          :class="{ 'selected': picked_type === type }">
          {{ dataTypeFormat(type) }}
        </div>
      </div>
      <div class="switch-time-format">
        <div v-for="unit, index in time_unit" :key="index" class="switch-btn"
          :class="{ 'selected': time_format === unit }" @click="switchTimeFormat(unit)">
          {{ timeUnitFormat(unit) }}
        </div>
      </div>
    </div>
    <canvas v-show="picked_type === 'power'" ref="powerChart"></canvas>
    <canvas v-show="picked_type === 'current'" ref="currentChart"></canvas>
    <canvas v-show="picked_type === 'electricity'" ref="electricityChart"></canvas>
  </div>
</template>

<script>
import { chartMixin } from '../mixins/chartMixin';

export default {
  mixins: [chartMixin],
  data() {
    return {
      time_unit: ['day', 'week', 'month', 'year'],
      data_types: ['power', 'current', 'electricity'],
      picked_type: 'power',
      defaultSetup: {
        tension: 0.1,
        pointRadius: 2,
        pointHoverRadius: 5,
        pointHitRadius: 50,
        pointBorderWidth: 2,
        type: "line",
        tension: .4,
        pointRadius: 0,
      },
      powerChartInstance: null,
      currentChartInstance: null,
      electricityChartInstance: null,
      powerCtx: null,
      currentCtx: null,
      electricityCtx: null,
    }
  },
  computed: {
    time_format() {
      return this.$store.getters.historicalDataTimeFormat;
    },
    meter() {
      return this.$store.getters.selectedMeter;
    },
    scaleColors() {
      return this.$store.getters.scaleColors
    },
  },
  watch: {
    time_format() {
      this.initChart();
    },
    meter() {
      this.initChart();
    },
    deep: true
  },
  mounted() { this.initChartRefs(); },
  methods: {
    initChartRefs() {
      this.powerCtx = this.$refs.powerChart;
      this.currentCtx = this.$refs.currentChart;
      this.electricityCtx = this.$refs.electricityChart;
    },
    initChart() {
      this.destroyCharts();
      this.renderCharts();
    },
    destroyCharts() {
      if (this.powerChartInstance) {
        this.powerDatasets = [];
        this.powerChartInstance.destroy()
      }
      if (this.currentChartInstance) {
        this.currentDatasets = [];
        this.currentChartInstance.destroy()
      }
      if (this.electricityChartInstance) {
        this.electricityDatasets = [];
        this.electricityChartInstance.destroy()
      }
    },
    renderCharts() {
      this.meter.bx_circuits.forEach((circuit, index) => {
        let scaleColor = this.RGBformat(this.scaleColors[index]);
        let transparentScaleColor = this.RGBformat(this.scaleColors[index], 0.2);
        let power = [];
        let current = [];
        let kWh = [];
        let time = [];
        let electricityTime = [];
        let powerDataset = {};
        let currentDataset = {};
        let electricityDataset = {};

        circuit.cumulative_data.forEach((data) => {
          kWh.push(data.cumulative_ep);
          electricityTime.push(data.time);
        })
        circuit.electricity_data.forEach((data) => {
          time.push(data.time);
          power.push(data.power);
          current.push(data.current);
        })

        let commonSetup = {
          label: circuit.alias,
          borderColor: scaleColor,
          pointBorderColor: scaleColor,
          pointHoverBackgroundColor: scaleColor,
          backgroundColor: transparentScaleColor,
          pointBackgroundColor: transparentScaleColor,
        }

        this.powerDatasets.push(Object.assign(powerDataset, this.defaultSetup, commonSetup, { data: power }));
        this.currentDatasets.push(Object.assign(currentDataset, this.defaultSetup, commonSetup, { data: current }));
        this.electricityDatasets.push(Object.assign(electricityDataset, this.defaultSetup, commonSetup, { data: kWh }));
        this.lineChartTimes = time;
        this.lineChartLabels = time;
        this.electricityTimes = electricityTime;
        this.electricityLabels = electricityTime;
      });

      this.powerChartInstance = new Chart(this.powerCtx, this.powerConfig);
      this.currentChartInstance = new Chart(this.currentCtx, this.currentConfig);
      this.electricityChartInstance = new Chart(this.electricityCtx, this.electricityConfig);
    },
    getCanvasContent() {
      const canvas = this.$refs.myCanvas;
      const content = canvas.toDataURL('image/png');
      this.$store.commit('setCanvasContent', {
        channelId: this.circuit.id,
        content: content,
      });
    },
    switchDataType(type) {
      this.picked_type = type;
    },
    switchTimeFormat(time_format) {
      this.$store.commit('setHistoricalDataTimeFormat', time_format);
    },
    dataTypeFormat(type) {
      switch (type) {
        case "power":
          return "功率"
        case "current":
          return "電流"
        default:
          return "電度"
      }
    },
    timeUnitFormat(unit) {
      switch (unit) {
        case "year":
          return "年度趨勢"
        case "month":
          return "當月趨勢"
        case "week":
          return "本週趨勢"
        default:
          return "當日趨勢"
      }
    }
  },
  beforeDestroy() {
    this.destroyCharts();
  }
}
</script>
<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3px;

  .switch-btn {
    cursor: pointer;
    background-color: var(--bx-unselected-btn);
    font-size: .7rem;
    font-weight: bolder;
    width: 4rem;
    line-height: 1.8rem;
    text-align: center;
  }

  .switch-data-type {
    display: flex;

  }

  .switch-time-format {
    display: flex;

  }

  .selected {
    background-color: var(--bx-green);
    color: white;
    font-weight: normal;
  }
}
</style>
